import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ButtonSpinner({ className, show }) {
  const spinnerClass = classNames('spinner-border ml-3', {
    [`${className}`]: true,
    'd-inline-block': show === true,
    'd-none': show === false,
  });

  return (
    <div className={spinnerClass} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}

ButtonSpinner.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
};

ButtonSpinner.defaultProps = {
  className: '',
  show: false,
};

export default ButtonSpinner;
